import { useQuery, UseQueryResult } from '@tanstack/react-query';
import adserver, { AxiosError } from 'services/adserver';
import { proposalsKeys } from './proposals.keys';
import { Proposal } from './proposals.types';
import { normalizeApiResponse } from './proposals.helpers';

const getProposalsByBasket = async (basketId: number): Promise<Proposal[]> => {
  const { data } = await adserver({
    url: `/basket/${basketId}/proposals`,
    headers: {},
  });
  return data.map((proposal: Proposal) => normalizeApiResponse(proposal));
};

export const useGetProposalsByBasket = (
  basketId: number,
): UseQueryResult<Proposal[], AxiosError> =>
  useQuery<Proposal[], AxiosError>({
    queryKey: proposalsKeys.basket(basketId),
    queryFn: () => getProposalsByBasket(basketId),
    enabled: !!basketId,
  });
